import React from 'react'
import AscentLogo from '../../../img/logo-ascent.png'
import Modal from './Modal'

export default () => (
    <Modal>
        <div className="about">
            <header>
                <h2 className="title">About</h2>
            </header>
            <p>
                Site Check is a free and public mapping tool that helps users quickly find parcels where housing
                projects may qualify for streamlining and exemptions under the California Environmental Quality Act
                (CEQA). Developers and public agencies considering how CEQA may apply to a housing project can turn to
                Site Check as a "first step" in their evaluations. It is funded by the California Housing and Community
                Development Department as part of the technical assistance for SB 2, the Building Homes and Jobs Act.
            </p>
            <p>
                The tool primarily uses the Python and JavaScript programming languages, with the Django and ReactJS
                frameworks. The mapping functionality is implemented using the Mapbox GL JS library along with tiled,
                vector parcel data in order to support high-performance mapping of the 11+ million parcels in the state
                of California. Spatial data is stored and analyzed using the PostgreSQL database with the PostGIS
                spatial extension.
            </p>
            <p>
                <strong>
                    Users should not construe as legal advice any contents of, or outputs from, Site Check, and should
                    independently verify all determinations.
                </strong>
            </p>
            <h4 className="title is-4">Purpose of Site Check</h4>
            <p>
                The purpose of Site Check is to accelerate the production of housing by facilitating planning decisions
                and clarifying where existing streamlining options under the California Environmental Quality Act (CEQA)
                may apply.
            </p>
            <h4 className="title is-4">Site Check's Functions</h4>
            <p>
                Site Check allows users to filter parcels based on specific CEQA provisions or whether the parcels meet
                certain requirements, like whether they are in an urbanized area, within a certain distance to transit,
                or covered by a specific plan. Users can also avoid parcels in environmentally sensitive areas like
                wetlands, natural hazard zones, or flood plains. More information about the underlying data can be found
                on the "Methods" page.
            </p>
            <p>
                Once the user has selected all the parcels of interest, a report can be created and downloaded to see
                the potential accelerated pathways to CEQA compliance that may apply based on the location of the
                parcels. A Site Check report cannot determine that a project is exempt from CEQA. However, it can
                provide a helpful starting point and guide users to the appropriate provisions within CEQA.
            </p>
            <h4 className="title is-4">Provisions within Site Check</h4>
            <p>
                This tool is focused on the CEQA provisions that cover a variety of housing types. The Legislature has
                also created specialized provisions for specific types of projects, like affordable housing,
                agricultural employee housing, and motel-to-supportive housing conversions. Those provisions are
                detailed on the "Other Resources" page.
            </p>
            <p>
                Note that other local or state provisions may apply that make a project ministerial or "by right" and
                therefore not subject to CEQA. Click on Other Resources for more information about this possibility.
            </p>
            <h4 className="title is-4">Acknowledgements</h4>
            <p>Site Check was made possible thanks to the assistance of the following partners:</p>
            <div className="acknowledgments">
                <div className="acknowledgment">
                    <u>California's Cities, Towns, Counties, and Metropolitan Planning Organizations</u>
                </div>
                <span>and</span>
                <div className="acknowledgment">
                    <a href="https://www.ascentenvironmental.com/" target="_blank">
                        <img src={AscentLogo} alt="Ascent Environmental" style={{ height: '60px' }} />
                    </a>
                </div>
            </div>
        </div>
    </Modal>
)
